(function(){
  if(!document.body.classList.contains('template-index'))return;
  var selector='main.main-content > .shopify-section, main.main-content > section, #PageContainer > .shopify-section, #PageContainer > section.bb-reels, #PageContainer > section.bb-services, #PageContainer > section.bb-wide-banner';
  function init(){
    var candidates=Array.from(document.querySelectorAll(selector));
    // Older themes can place homepage content inside the main rather than section wrappers.
    if(!candidates.length){candidates=Array.from(document.querySelectorAll('main.main-content > div')).filter(function(el){return !el.hidden;});}
    if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('bb-scroll-visible');observer.unobserve(e.target);}});},{threshold:0.07,rootMargin:'0px 0px 150px 0px'});
    candidates.forEach(function(el){
      if(el.dataset.bbRevealReady)return;
      el.dataset.bbRevealReady='true';
      
      el.classList.add('bb-scroll-reveal');observer.observe(el);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
